import { cn } from "@newxsystems/shared";
import { GroundCardLink } from "../GroundCardLink/GroundCardLink";
import { GroundMedia } from "../GroundMedia/GroundMedia";
import { GroundRichText } from "../GroundRichText/GroundRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div
    className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
  >
    {items.map((item, index) => (
      <GroundCardLink className="overflow-visible border-0" key={index} link={item.cardLink}>
        <GroundMedia
          aspectRatio={imageAspectRatio || "16:9"}
          imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.015]"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="border-t border-weathered-steel pt-5">
          <h3 className="font-ground-display text-2xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <GroundRichText
              className="mt-3 text-base text-basalt md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
      </GroundCardLink>
    ))}
  </div>
);

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
